import * as d3 from "d3";

export interface IObjectLocation {
    Label: string;
    BaseHash: string;
    OnCall?: () => void;
}

export class LocationNav {
    private locations: Map<string, IObjectLocation>;
    private divControl: d3.Selection<HTMLDivElement, {}, HTMLElement, null>

    constructor(parentSelection: d3.Selection<HTMLDivElement, any, any, any>) {
        this.locations = new Map();
        this.divControl = parentSelection;
    }

    private DrawLocations() {
        let locationsAux = Array.from(this.locations.values())
        this.divControl
            .selectAll("div")
            .data(locationsAux, (d: any) => d)
            .join(
                enter => {
                    return enter.append<HTMLDivElement>((d, i) => {
                        let div = d3.create<HTMLDivElement>("div");
                        let labelLocation = div.append<HTMLLabelElement>("label").text(() => d.Label)
                        let isLastD = (d === locationsAux[locationsAux.length - 1]);

                        if (!isLastD && d.OnCall) { // || d.OnClick)) {
                            labelLocation.classed("lbl_location_enable", true);
                            labelLocation.on("click", () => {
                                d.OnCall();
                            })
                        } else {
                            labelLocation.classed("lbl_location_enable", false);
                        }
                        if (i < this.locations.size - 1) div.append<HTMLSpanElement>("span").text("/")
                        return div.node()
                    })
                },
                update => {
                    if (update.select("span").node() === null) {
                        return update.append<HTMLSpanElement>((d, i) => {
                            let span = d3.create<HTMLSpanElement>("span")
                            if (i < this.locations.size - 1) span.text("/")
                            return span.node()
                        })
                    } else {
                        return update.select("span").text((d, i) => {
                            return i < this.locations.size - 1 ? "/" : ""
                        })
                    }
                },
                exit => exit.remove()
            )
    }

    // ****************************************************************
    // PUBLIC PROPERTIES
    // ****************************************************************

    /** Actualiza la barra de navs con los elementos nuevos */
    public _UpdateLocations(newLocations: Array<IObjectLocation>) {
        this.locations.clear();
        this.DrawLocations();
        newLocations.forEach(d => this.locations.set(d.BaseHash, d));
        this.DrawLocations();
    }
}
